import './style.scss';

import Swiper from 'swiper';
import { Autoplay } from 'swiper/modules';

document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.booom-logos .logos-swiper').forEach((swiperEl) => {
        new Swiper(swiperEl, {
            modules: [Autoplay],
            spaceBetween: 65,
            slidesPerView: 6,
            centeredSlides: true,
            breakpoints: {
                0: { slidesPerView: 2 },
                550: { slidesPerView: 3 },
                768: { slidesPerView: 4 },
                1024: { slidesPerView: 6 },
            },
            autoplay: {
                delay: 3500,
                disableOnInteraction: false,
            },
            loop: true,
        });
    });
});